import { render } from "./ManageTopics.vue?vue&type=template&id=4c5f85cb"
import script from "./ManageTopics.vue?vue&type=script&lang=js"
export * from "./ManageTopics.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/staging/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__